import AppFallback from "@/components/ui/AppFallback/AppFallback";
import { createBrowserRouter } from "react-router-dom";

import { clientRouteConfigs } from "./routeConfigs/clientRouteConfig";

export const appRouter = () => {
  return createBrowserRouter([
    {
      errorElement: (
        <AppFallback
          title="Something went wrong"
          message="This screen failed to load. Reloading usually fixes it."
          showReload
        />
      ),
      children: [...clientRouteConfigs],
    },
  ]);
};

export default appRouter;
